<template>
  <IQOS :systemDependency="mode == 'inside' ? 'inside' : null" required class="stickers-buy-card gap-column-xs">
    <div class="first-part">
      <div>
       <BaseHeader>
          <template #title>
            {{ $t("stickers_static.title")  }}
          </template>
       </BaseHeader>
       <p class="iqos-comment qrw-paragraph-md v1-grey-10-color mt-16">
         {{ $t("stickers_static.comment_none", {
           mode: mode.toUpperCase()
         }) }}
       </p>
       <p class="iqos-comment qrw-paragraph-md v1-grey-10-color mt-16">
         {{ $t("stickers_static.comment_none2") }}
       </p>
      </div>
      <div class="button-container gap-column-xs">
       
        <BaseButton
          size="md"
          color="v1-grey-10"
          variant="secondary"
          icon="download">
           <a class="qrw-button-text download-hover" target="_blank" :href="`/api/shipment/download_qrcodes/${cafe._id}`">
            {{ $t('stickers_static.download') }}
            </a>
        </BaseButton>
        
        <!-- <BaseButton
          size="md"
          color="green-6"
          variant="primary"
          icon="cart"
          bold
          @click="$router.push('/stickers_gallery')"
          class="buy-button bold w-100"
        >
          {{ $t("stickers_static.button") }}
        </BaseButton> -->
      </div>
    </div>
    <img class="image" src="/icons/stickers-buy-card-image.png" />
  </IQOS>
</template>
<script>
import DashboardButton from "./DashboardButton.vue";
export default {
  components: {
    DashboardButton,
  },
  props: {
    mode: {
      type: String,
      default: 'inside'
    }
  },
  computed: {
    uiStage() {
      return this.$store.state.cafe.activated ? "active" : "none";
    },
    cafe() {
      return this.$store.state.cafe;
    }
  },
};
</script>
<style scoped>
.stickers-buy-card {
  display: flex;
  padding: 0;
}
.first-part {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  padding: 16px;
}

.button-container {
  display: flex;
  width: 100%;
}

.image {
  height: auto;
  max-width: 415px;
  border-radius: 8px;
}

.download-hover {
  color: var(--v1-grey-10-color);
}

.button-container:hover .download-hover {
  color: var(--v1-grey-1-color);
}

a {
  text-decoration: none;
}
</style>
